import React from 'react';
import '../styles/contact.css';

const ContactMap = () => {
  return (
    <div className="map-container mb-5">
      <iframe
        title="Sarbet, Addis Ababa Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12294.106560848999!2d38.72386022324054!3d9.001389126722925!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85cc6581567f%3A0xf777938d1232187f!2sBlue%20Nest%20Hotel!5e1!3m2!1sen!2set!4v1763268111766!5m2!1sen!2set"
        height="400"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>
    </div>
  );
};


export default ContactMap;
